import { Injectable } from '@angular/core';
import SessionStorage from '@app/helpers/SessionStorage';

@Injectable({
  providedIn: 'root'
})
export class SessionstorageService {

  constructor() { }

  ChatVisibility(): boolean {
    return SessionStorage.ChatVisibility == "Y" ? true : false;
  }
}
